import { ComputeEvaluator, type StateAccessor } from "./compute-evaluator"

/**
 * Expression evaluator — delegates to ComputeEvaluator (safe recursive-descent parser).
 * Replaces the old `new Function()` approach with a secure, cross-platform implementation.
 */
export class ExpressionEvaluator {
  private compute: ComputeEvaluator

  constructor(state: StateAccessor) {
    this.compute = new ComputeEvaluator(state)
  }

  evaluate(expression: string): unknown {
    return this.compute.evaluate(expression)
  }

  /** Expose the underlying ComputeEvaluator for predicate evaluation. */
  getCompute(): ComputeEvaluator {
    return this.compute
  }
}
